import React from "react";

function ArrowRight() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
    >
      <path
        d="M14.1316 8.3378L11.3031 11.1662C11.2094 11.26 11.0822 11.3127 10.9496 11.3127C10.817 11.3127 10.6898 11.26 10.596 11.1662C10.5022 11.0725 10.4496 10.9453 10.4496 10.8127C10.4496 10.6801 10.5022 10.5529 10.596 10.4591L12.5711 8.48409C6.77515 8.48444 8.90583 8.4857 3.22275 8.48613C3.09006 8.48613 2.96282 8.43342 2.869 8.3396C2.77518 8.24578 2.72247 8.11853 2.72247 7.98585C2.72247 7.85317 2.77518 7.72592 2.869 7.6321C2.96282 7.53828 3.09006 7.48557 3.22275 7.48557C8.93784 7.48557 6.81585 7.48442 12.5711 7.48442L10.596 5.50938C10.5023 5.41561 10.4496 5.28843 10.4496 5.15583C10.4496 5.02322 10.5023 4.89604 10.596 4.80228C10.6898 4.70851 10.817 4.65583 10.9496 4.65583C11.0822 4.65583 11.2094 4.7085 11.3031 4.80227L14.1316 7.6307C14.2253 7.72447 14.278 7.85164 14.278 7.98425C14.278 8.11686 14.2253 8.24404 14.1316 8.3378Z"
        fill="#89888D"
      />
    </svg>
  );
}

export default ArrowRight;
